import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";
import { loadConsent } from "./cookieConsent";

const dsn = import.meta.env.VITE_SENTRY_DSN;

let initialized = false;

function initSentry() {
  if (initialized || !dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    tracesSampleRate: 0.2,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterBrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
  });
  initialized = true;
}

export function syncSentryConsent(analyticsConsent: boolean) {
  if (analyticsConsent) return initSentry();
  // Consent withdrawn mid-session — stop sending events; a later opt-in re-inits.
  if (!initialized) return;
  Sentry.close();
  initialized = false;
}

// Initialize immediately for returning visitors who already granted analytics
// consent in a prior session, so early errors aren't missed.
const stored = loadConsent();
if (stored?.categories.analytics) initSentry();

export { Sentry };
